const NS_SLD = "http://www.opengis.net/sld";
const NS_SE = "http://www.opengis.net/se";
const NS_OGC = "http://www.opengis.net/ogc"

const INITIAL_BYTES = 10000000;

class SLD {
	constructor(title, version, propertyNames) {
		this.title = title;
		this.version = version;
		this.propertyNames = propertyNames;	
	}
	
	getTitle() {
		return this.title;
	}
	
	getVersion() {
		return this.version;
	}
	
	getPropertyNames() {
		return this.propertyNames;
	}

}

const readText = async( reader ) => {
	let resultText = "";
	
	let bytesRead = INITIAL_BYTES;
	let offset = 0;

	while( bytesRead == INITIAL_BYTES) {
		const buffer = await reader.read(offset, offset + INITIAL_BYTES);
		bytesRead = buffer.byteLength;
		
		const text = new TextDecoder().decode( buffer );
		resultText = `${resultText}${text}`	
		offset = offset + buffer.byteLength;			
	}
	
	return resultText;	
}


const getElements = (document, tagName, ns) => {
    const namespaces = ns || [NS_SLD, NS_SE]
    
    let results = [];
    for( let i = 0; i < namespaces.length && results.length === 0; i++) {
        results = document.getElementsByTagNameNS(namespaces[i], tagName);
    }
    
    return results;                
};

const getElement = (document, parentElement, element) => {
    let rootElement = document;
    let previous = null;
    const path = [parentElement, element];
    
    for( let i = 0; i < path.length && rootElement; i++ ) {
        let element = getElements(rootElement, path[i]);   
        if( element && element.length > 0 && (previous === null || element[0].parentNode === previous) ) {
            rootElement = element[0];
            previous = element[0];
        } else {
            rootElement = null;
        }
    }
    
    return rootElement;
}

const sld = async (sldFile) => {    
    const text = await readText( sldFile );    
    const document = new DOMParser().parseFromString(text, "text/xml");
        
	const sld = getElements(document, "StyledLayerDescriptor");
    const valid = sld && sld.length > 0;        
	
	let result = null;
        
    if( valid ) {
		const version = sld[0].getAttribute("version");
    	        
    	let title = undefined;
		const propertyNames = [];
    	    	
    	const titleElement = getElement(document, "UserStyle", "Title") || getElement(document, "UserStyle", "Name") || getElement(document, "NamedLayer", "Name");           
    	if( titleElement ) {
        	title = titleElement.textContent;
    	}
    	
    	const propertyName = getElements(document, "PropertyName", [NS_OGC]);
    	for(let i = 0; propertyName && i < propertyName.length; i++) {
	    	propertyNames.push(propertyName[i].textContent);                    
        }
        
        result = new SLD(title, version, propertyNames);
    }       
    
    return result;
}

export {
	sld
}